export const handleUpdate = variantId => {
    const format = window.variantFormats[variantId];
    const formatLabels = window.formatLabels;
    const formatEl = document.querySelector('.product-format--data');
    
    if (!format) {
        formatEl.innerHTML = '';
        return;
    }

    const start = '<span class="divider">'
    const end = '</span>'
    const parts = [];
    
    for (const key in format) {
        if (format[key] && formatLabels[key]) {
            parts.push(`${start}${formatLabels[key]}${format[key]}${end}`);
        }
    }
    
    formatEl.innerHTML = parts.join('');
};
// Listen for variant changes
FoxTheme?.pubsub?.subscribe("variant-change", ({ data }) => {
    const variant = data?.variant;
    if (variant?.id) handleUpdate(variant.id);
});